import { AePeriod } from 'activity-editor/context';
import { ActivityUpdateBatchRequest, ActivityUpdateRequestPeriodAndAthletes } from 'oas';

export const buildActivitySaveRequest = (
    activityId: string,
    periods: AePeriod[],
): ActivityUpdateBatchRequest & { id: string } => {
    return {
        id: activityId,
        periods: periods.map(
            (period: AePeriod): ActivityUpdateRequestPeriodAndAthletes => ({
                id: period.id,
                name: period.name,
                start_time_ms: period.startDateTime.valueOf(),
                end_time_ms: period.endDateTime.valueOf(),
                athletes: period.athleteIds.map((id) => ({
                    athlete_id: id,
                })),
            }),
        ),
    };
};
